import { Ok } from '@atom-learning/icons'
import * as RadixSelect from '@radix-ui/react-select'
import * as React from 'react'

import { styled } from '~/styled'

import { Icon } from '../icon/Icon'
import { useSelectMenuContext } from './SelectMenuContext'

const Item = styled(RadixSelect.Item, {
  base: [
    'relative',
    'flex',
    'items-center',
    'text-grey-1000',
    'font-body',
    'font-normal',
    'cursor-pointer',
    'rounded-sm',
    'outline-none',
    'data-disabled:cursor-not-allowed',
    'data-disabled:opacity-30',
    'data-disabled:pointer-events-none',
    'data-highlighted:bg-grey-100',
    'data-highlighted:outline-none'
  ],
  variants: {
    size: {
      sm: ['py-1.5', 'pl-7', 'pr-4', 'text-sm'],
      md: ['py-2', 'pl-8', 'pr-6'],
      lg: ['py-2', 'pl-8', 'pr-6']
    }
  }
})

type SelectMenuItemProps = React.ComponentPropsWithRef<typeof RadixSelect.Item>

export const SelectMenuItem = React.forwardRef<
  HTMLDivElement,
  SelectMenuItemProps
>(({ children, ...props }, ref) => {
  const { size } = useSelectMenuContext()

  return (
    <Item ref={ref} size={size} {...props}>
      <RadixSelect.ItemIndicator className="absolute left-2 inline-flex items-center">
        <Icon is={Ok} className={size === 'sm' ? 'size-3' : 'size-4'} />
      </RadixSelect.ItemIndicator>
      <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
    </Item>
  )
})

SelectMenuItem.displayName = 'SelectMenuItem'
